import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const MP_NAVIGATE_SLIDE = 'MP_NAVIGATE_SLIDE';

/**
 * Always-visible deck controls. The read-only harness owns slide state, so the
 * arrows drive it through the same MP_NAVIGATE_SLIDE message it already listens
 * for on the window.
 */
export function DeckNav() {
  const navigate = (direction: 'prev' | 'next') => {
    window.postMessage({
      type: MP_NAVIGATE_SLIDE,
      direction
    }, '*');
  };
  return <nav aria-label="Slide navigation" className="screen-only fixed bottom-[2.5vh] left-1/2 z-50 flex -translate-x-1/2 items-center gap-[0.9vw] rounded-full border border-white/15 bg-black/50 px-[0.8vw] py-[0.8vh] backdrop-blur-md" data-id="element-17" data-mp="3ig47e5xfn9ad">
      <NavButton label="Previous slide" onClick={() => navigate('prev')} icon={<ChevronLeftIcon className="h-[1.4em] w-[1.4em]" data-id="element-19" data-mp="16np4lghdfgnn" />} data-id="element-18" data-mp="3nckx34ka5vpk" />
      <span className="text-[clamp(9px,0.8vw,14px)] uppercase tracking-[0.28em] text-white/45" data-id="element-20" data-mp="12nf0k9d530bf">
        Slide
      </span>
      <NavButton label="Next slide" onClick={() => navigate('next')} icon={<ChevronRightIcon className="h-[1.4em] w-[1.4em]" data-id="element-22" data-mp="14fr826rhohlp" />} data-id="element-21" data-mp="zge8qmjfli28" />
    </nav>;
}
type NavButtonProps = {
  label: string;
  onClick: () => void;
  icon: React.ReactNode;
};
function NavButton({
  label,
  onClick,
  icon
}: NavButtonProps) {
  return <button type="button" onClick={onClick} aria-label={label} className="flex h-[clamp(34px,3.4vw,60px)] w-[clamp(34px,3.4vw,60px)] items-center justify-center rounded-full border border-[color:var(--sv-green)]/50 bg-[color:var(--sv-green)]/12 text-[clamp(12px,1.1vw,20px)] text-white transition-colors hover:bg-[color:var(--sv-green)] hover:text-[#05110c] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--sv-green)]" data-id="element-23" data-mp="1df4hx0jiz86y">
      {icon}
    </button>;
}